import { render, staticRenderFns } from "./templateMatch.vue?vue&type=template&id=b2a5af78&scoped=true&"
import script from "./templateMatch.vue?vue&type=script&lang=js&"
export * from "./templateMatch.vue?vue&type=script&lang=js&"
import style1 from "./templateMatch.vue?vue&type=style&index=1&id=b2a5af78&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a5af78",
  null
  
)

export default component.exports